import * as React from 'react';
import { connect } from 'react-redux';
import { getOperationSafe, getOperation } from 'selectors';
import { IState } from 'services/root-reducer';
import {
    ObjectLinkOverlayOperation,
    actions as overlayWindowsActions
} from 'services/overlay-windows/overlay-windows-service';
import {
    OverlayContainer,
    LinkWindow
} from 'components';

export interface IObjectLinkOverlayProps {
    objectLinkOverlay: ObjectLinkOverlayOperation;
}
export interface IObjectLinkOverlayState {

}

const mapStateToProps = (state: IState) => ({
    objectLinkOverlay: getOperationSafe(state, 'OBJECT_LINK_OVERLAY')
});

/* eslint-disable @typescript-eslint/indent */
class ObjectLinkOverlayComponent extends React.Component<
    IObjectLinkOverlayProps,
    IObjectLinkOverlayState
    > {
    /* eslint-enable @typescript-eslint/indent */

    constructor(props: IObjectLinkOverlayProps) {
        super(props);
    }

    render() {
        let { objectLinkOverlay } = this.props;

        if (!objectLinkOverlay.data?.visible) {
            return null;
        }

        return (
            <OverlayContainer
                className='object-link-overlay'
                backgroundOpacity={8}
            >
                <LinkWindow
                    link={objectLinkOverlay.data?.link}
                    onClose={() => {
                        overlayWindowsActions.hideObjectLinkOverlay();
                    }}
                />
            </OverlayContainer>
        );
    }
}

export const ObjectLinkOverlay = connect(mapStateToProps)(ObjectLinkOverlayComponent);
